import {
  keepPreviousData,
  useMutation,
  useQuery,
  useQueryClient,
} from "@tanstack/react-query";
import { salesApi } from "@/api/sales/sales-api";
import type {
  SaleCheckout,
  SaleSearchParams,
  WalkInSaleCreate,
} from "@/types/sales/api-types/sale-types";

export const useGetSalesPaginated = (params: SaleSearchParams = {}) =>
  useQuery({
    queryKey: ["sales", params],
    queryFn: () => salesApi.getAll(params),
    placeholderData: keepPreviousData,
  });

export const useCheckoutSale = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ id, data }: { id: number; data: SaleCheckout }) =>
      salesApi.checkout(id, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sales"] });
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
    },
  });
};

export const useCreateWalkInSale = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: WalkInSaleCreate) => salesApi.createWalkIn(data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["sales"] });
      queryClient.invalidateQueries({ queryKey: ["appointments"] });
    },
  });
};
